import { PayloadAction, createSlice } from '@reduxjs/toolkit'

import { AppState } from 'app/store'

import { getUserTypeAssertions } from 'utils/helper'

export interface TState {
    userTypeAssertions: {
        isTeamMember: boolean
        isTeamOwner: boolean
        isSuperAdmin: boolean
        isCustomerSupportUser: boolean
    }
    resetPasswordForUserEmail: string
    isAuthenticated: boolean
    token: string
    url: string
}

export const initialState: TState = {
    userTypeAssertions: {
        isTeamMember: false,
        isTeamOwner: false,
        isSuperAdmin: false,
        isCustomerSupportUser: false,
    },
    resetPasswordForUserEmail: '',
    isAuthenticated: false,
    token: '',
    url: '',
}

const userLoginSlice = createSlice({
    name: 'userManagement',
    initialState,
    reducers: {
        initUserPasswordReset: (state, action: PayloadAction<string>) => {
            return {
                ...state,
                resetPasswordForUserEmail: action.payload,
            }
        },
        onLoginSuccess: (state, action: PayloadAction<string>) => {
            return {
                ...state,
                isAuthenticated: true,
                token: action.payload,
                userTypeAssertions: getUserTypeAssertions(action.payload),
            }
        },
        onLogout: state => {
            return {
                ...state,
                isAuthenticated: false,
                token: '',
            }
        },
    },
})

export const userTypeAssertions = (state: AppState) => {
    return state.userManagement.userTypeAssertions
}
export const getIsUserAuthenticated = (state: AppState) => state.userManagement.isAuthenticated
export const getUserToken = (state: AppState) => state.userManagement.token

export default userLoginSlice.reducer

export const { initUserPasswordReset, onLogout, onLoginSuccess } = userLoginSlice.actions
